module.exports = __webpack_public_path__ + "static/media/icita2004.4ef5a8e0.png";